import { Link } from "react-router-dom";
import { useState } from "react";
import { memberApi, formatApiError } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await memberApi.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-[#0a0a0a]" data-testid="forgot-password-page">
      <div className="w-full max-w-md bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-8 shadow-2xl">
        <h1 className="text-3xl font-light text-[#C97654] mb-2 text-center">Reset Password</h1>
        <p className="text-[#E8DCC4]/60 text-sm text-center mb-6">
          Enter the email on your Passion Pilates account and we'll send you a reset link.
        </p>

        {sent ? (
          <div data-testid="forgot-success" className="bg-[#C97654]/20 border border-[#C97654] rounded-lg px-4 py-4 text-center">
            <p className="text-[#FFB89A] font-bold mb-1">Check your inbox ✨</p>
            <p className="text-[#E8DCC4]/70 text-sm">If an account exists with that email, a reset link has been sent.</p>
          </div>
        ) : (
          <>
            {error && (
              <div className="mb-4 bg-[#8B2635]/20 border border-[#8B2635] rounded-lg px-4 py-3 text-[#FFB89A] text-sm">{error}</div>
            )}
            <form onSubmit={onSubmit} className="space-y-5">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="forgot-email-input"
                className="w-full bg-[#0a0a0a] border-2 border-[#2a2a2a] focus:border-[#C97654] rounded-lg px-4 py-3 text-[#E8DCC4] placeholder-[#E8DCC4]/30 transition-colors outline-none"
              />
              <button
                type="submit"
                disabled={submitting}
                data-testid="forgot-submit-btn"
                className="w-full bg-gradient-to-r from-[#C97654] to-[#FF9472] text-white py-3 rounded-lg font-bold transition-all duration-300 shadow-md disabled:opacity-50"
              >
                {submitting ? "Sending…" : "Send Reset Link"}
              </button>
            </form>
          </>
        )}

        <div className="mt-6 text-center text-sm">
          <Link to="/app/login" className="text-[#E8DCC4]/70 hover:text-[#C97654] transition-colors">← Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
